import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "context";
import LogoutOnExpiration from "components/App/LogoutOnExpiration";
import SelectRoleModal from "context/Auth/SelectRoleModal";
import { buildRoute } from "routes";

/**
 * Layout route guard: protects all nested routes from unauthenticated access.
 * - Unauthenticated → redirect to /connexion?redirect=<intended-path>
 * - Multi-role account with no role chosen → block with SelectRoleModal
 * - Authenticated → render nested routes wrapped in LogoutOnExpiration
 */
const AuthGuard: React.FC = () => {
    const auth = useContext(AuthContext);
    const location = useLocation();

    if (!auth.isLoggedIn) {
        return <Navigate to={buildRoute.loginWithRedirect(location.pathname + location.search)} replace />;
    }

    if (auth.displaySelectRole()) {
        return <SelectRoleModal roles={auth.account?.user.roles!} selectRole={auth.selectRole} />;
    }

    return (
        <LogoutOnExpiration>
            <Outlet />
        </LogoutOnExpiration>
    );
};

export default AuthGuard;
